import { NotFound } from 'components/common/NotFound';
import GenreFeature from 'features/Genre';
import MenuList from 'features/MenuList/pages/MenuList';
import SubGenreFeature from 'features/SubGenre';
import SubMenuListFeature from 'features/SubMenuList';
import SubTitleMenu from 'features/SubTitleMenu';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import MenuBookListPage from './pages/MenuBookListPage';

function MenuBookFeature() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${path}/menu-book-list`} />
      </Route>
      <Route path={`${path}/menu-book-list`}>
        <MenuBookListPage />
      </Route>
      <Route path={`${path}/genre`}>
        <GenreFeature />
      </Route>
      <Route path={`${path}/sub-genre`}>
        <SubGenreFeature />
      </Route>
      <Route path={`${path}/menu-list`}>
        <MenuList />
      </Route>
      <Route path={`${path}/sub-menu-group-list`}>
        <SubMenuListFeature />
      </Route>
      <Route path={`${path}/subtitle-menu-list`}>
        <SubTitleMenu />
      </Route>
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
}

export default MenuBookFeature;
